export default __webpack_public_path__ + "static/media/pepsico-logo-white.9172731d.png";